import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICommonService, IWebRequest } from './iapp.config';

@Injectable()
export class WebRequest implements IWebRequest {
  get: <T>(
    url: string,
    data?: any,
    header?: any,
    goToErrorState?: boolean
  ) => Observable<T>;
  post: <T>(
    url: string,
    data?: any,
    header?: any,
    goToErrorState?: boolean
  ) => Observable<T>;
  postFile: <T>(
    url: string,
    data?: any,
    header?: any,
    goToErrorState?: boolean
  ) => Observable<T>;
  putFile: <T>(
    url: string,
    data?: any,
    header?: any,
    goToErrorState?: boolean
  ) => Observable<T>;
  put: <T>(
    url: string,
    data?: any,
    header?: any,
    goToErrorState?: boolean
  ) => Observable<T>;
  delete: <T>(
    url: string,
    data?: any,
    header?: any,
    goToErrorState?: boolean
  ) => Observable<T>;

  constructor(
    private http: HttpClient,
    @Inject('ICommonService') private commonService: ICommonService
  ) {
    this.get = <T>(
      url: string,
      data?: any,
      header?: any,
      goToErrorState?: boolean
    ) => {
      const options = this.getRequestOption(
        'get',
        url,
        data,
        this.commonService.getRequestHeader()
      );
      return this.http.get<T>(url, options);
    };

    this.post = <T>(
      url: string,
      data?: any,
      header?: any,
      goToErrorState?: boolean
    ) => {
      const options = this.getRequestOption(
        'post',
        url,
        {},
        header ? header : this.commonService.getRequestHeader()
      );
      return this.http.post<T>(url, data, options);
    };

    this.put = <T>(
      url: string,
      data?: any,
      header?: any,
      goToErrorState?: boolean
    ) => {
      const options = this.getRequestOption(
        'put',
        url,
        {},
        header ? header : this.commonService.getRequestHeader()
      );
      return this.http.put<T>(url, data, options);
    };

    this.delete = <T>(
      url: string,
      data?: any,
      header?: any,
      goToErrorState?: boolean
    ) => {
      const options = this.getRequestOption(
        'delete',
        url,
        {},
        header ? header : this.commonService.getRequestHeader()
      );
      return this.http.delete<T>(url, options);
    };
    this.postFile = <T>(
      url: string,
      data?: any,
      header?: any,
      goToErrorState?: boolean
    ) => {
      const options = this.getRequestOption(
        'post',
        url,
        {},
        header ? header : this.commonService.getRequestFileHeader()
      );
      return this.http.post<T>(url, data, options);
    };
    this.putFile = <T>(
      url: string,
      data?: any,
      header?: any,
      goToErrorState?: boolean
    ) => {
      const options = this.getRequestOption(
        'put',
        url,
        {},
        header ? header : this.commonService.getRequestFileHeader()
      );
      return this.http.put<T>(url, data, options);
    };
  }
  private genParams(
    params: { [key: string]: any },
    httpParams = new HttpParams()
  ): object {
    Object.keys(params)
      .filter((key) => {
        const v = params[key];
        return Array.isArray(v) || typeof v === 'string'
          ? v.length > 0
          : v !== null && v !== undefined;
      })
      .forEach((key) => {
        httpParams = httpParams.set(key, params[key]);
      });
    return { params: httpParams };
  }
  private getRequestOption(method: any, url: string, data?: any, header?: any) {
    const httpParams = new HttpParams();

    const options = {
      headers: header,
      responseType: 'json' as const,
      params: httpParams,
    };
    const opts = Object.assign(
      {},
      options,
      data ? this.genParams(data, options.params) : null
    );

    return opts;
  }
}
